import React from 'react';
import { useLocation } from "react-router-dom";

import { Page } from "../../../_partials/Layout";
import NavBar2 from '../../../../componets/NavBar2';
import modsfactoryUrls from "../../../../configs/mods_factory/modsfactoryUrls";

interface PropsInterface {
  className?: string;
  children: React.ReactNode
}

const PageLayout: React.FC<PropsInterface> = (props) => {
  const PAGES: {[index: number]: any} = {
    1: {
      id: 1,
      name: 'Content',
      icon: 'fa-solid fa-grip',
      subcategories: [4, 6, 7, 5]
    },
    2: {
      id: 2,
      name: 'Community',
      icon: 'fa-solid fa-layer-group',
      url: modsfactoryUrls.addonsPath()
    },
    10: {
      id: 10,
      name: 'Users',
      icon: 'fa-solid fa-users',
      url: modsfactoryUrls.usersPath()
    },
    3: {
      id: 3,
      name: 'Reports',
      icon: 'exclamation-triangle',
      url: modsfactoryUrls.reportsPath()
    },

    // COMPONENTS NAV_DROPDOWN
    4: {
      id: 4,
      name: 'Skins',
      url: modsfactoryUrls.skinsPath()
    },
    5: {
      id: 5,
      name: 'Entities Skins',
      url: modsfactoryUrls.mainSkinsPath()
    },
    6: {
      id: 6,
      name: 'Maps',
      url: modsfactoryUrls.worldsPath()
    },
    7: {
      id: 7,
      name: 'Addon Templates',
      url: modsfactoryUrls.addonTemplatesPath()
    }
  };

  const PARENT_PAGE_IDS = [1, 2, 10, 3];
  const PAGE_IDS        = Object.keys(PAGES).map(id => parseInt(id, 10));

  const { pathname } = useLocation();
  const pageId = PAGE_IDS.find(id => pathname.includes(PAGES[id].url));

  return (
    <Page className={props.className}>
      <NavBar2 items={PAGES} itemIds={PARENT_PAGE_IDS} activeId={pageId} />

      <div className='v-layout--body'>
        {props.children}
      </div>
    </Page>
  );
}

export default PageLayout;
